import { stateService } from '../_services';

export const state = {
    namespaced: true,
    state: {
        all: [],
        ready: false
    },
    actions: {
        getStateCollection({ commit }) {
            commit('getAllRequest');

            stateService.getStateCollection()
                .then(
                    status => commit('getAllSuccess', status),
                    error => commit('getAllFailure', error)
                );
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
            state.ready = false;
        },
        getAllSuccess(state, status) {
            state.all = status['hydra:member'];
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.ready = false;
        }
    },
    getters: {
        showStateByIRI(state) {
            return iri => {
                return state.all.find(obj => obj['@id'] === iri)
            }
        },
        showStateCollection(state) {
            return state.all;
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
